import { render, staticRenderFns } from "./ResultDashboard.vue?vue&type=template&id=cf003988&scoped=true"
import script from "./ResultDashboard.vue?vue&type=script&lang=js"
export * from "./ResultDashboard.vue?vue&type=script&lang=js"
import style0 from "./ResultDashboard.vue?vue&type=style&index=0&id=cf003988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf003988",
  null
  
)

export default component.exports